import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { AppQuill } from "../../../../../Component/Common/Components/FormValidationInputs/AppQuill";
import { seniorManagersSchema } from "./SeniorManagersValidation";
import { SeniorManagersService } from "../../../../../Component/Api/EmploymentEquity/Plan/SeniorManagers/SeniorManagersService";
import { SeniorManagersDto } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/EESeniorManagers";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { EEScorecardAtom } from "../../../../../State/EEScorecard.Atom";
import { ConsolidationAtom } from "../../../../../State/Consolidation.Atom";
import { UserActivityService } from "../../../../../Component/Api/UserActivity/UserActivityService";
import { SeniorManagersSection } from "../../../../../Component/Common/Constants/UserActivityTrackingSections";
import { UserActivityActionType } from "../../../../../Component/Model/Enum/BEE123Enums";

interface IProps {
    scorecardId : string;
}

type InputForm = {
    detail?: string;
}

export const SeniorManagers: FC<IProps> = (props) => {

    const scorecard = useRecoilValue(EEScorecardAtom);
    const isConsolidatedScorecard = useRecoilValue(ConsolidationAtom);
    const maxConsolidatedDetailLength = 3000 * (scorecard.ConsolidationSourceScorecardsCount ?? 1);
    const maxDetailLength = isConsolidatedScorecard ? maxConsolidatedDetailLength : 3000;

    const { control, reset, getValues } = useForm<InputForm>({
        mode: 'all',
        resolver: yupResolver(seniorManagersSchema(maxDetailLength))
    });

    const getSeniorManagersData = async (scorecardId: string) => {
        try {
            const dataResponse = await SeniorManagersService.GetSeniorManagersInformation(scorecardId);
            const formData: InputForm = {
                detail: dataResponse.data.detail
            }
            reset(formData);
        } catch (error: any) {
            console.log(error);
        }
    }

    const saveSeniorManagersForm = async () => {
        const formData = getValues();

        seniorManagersSchema(maxDetailLength).validate(formData, { abortEarly: false }).then(async() => {
            const requestData: SeniorManagersDto.SeniorManagersDto = {
                scorecardId: props.scorecardId,
                detail: formData.detail
            }
            const response = await SeniorManagersService.SaveSeniorManagersInformation(requestData);
        }).catch(function (error: any) {
            toast.error(error.message);
        });
    }

    const seniorManagersLog = (actionType: number, actionDescription: string) => {
        UserActivityService.createActivityLog({
            section: SeniorManagersSection,
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
    }
    
    useEffect(() => {
        getSeniorManagersData(props.scorecardId);
        seniorManagersLog(UserActivityActionType.View, "View senior managers commentary");

        return () => {
            if (localStorage.getItem('coreToken') !== null) {
                saveSeniorManagersForm();
                seniorManagersLog(UserActivityActionType.Create, "Capture senior managers commentary");
            }
        }
    }, [props.scorecardId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box component="form" mt={2}>
            <Box>
                <AppQuill control={control} name='detail' label='Detail*' maxLength={maxDetailLength} />
            </Box>
        </Box>
    )
}